import styled from "@emotion/native";
import { ViewStyle } from "react-native";

export const Container = styled.View(
	{
		justifyContent: "flex-start",
		marginTop: 10,
	},
	({ isReverse }: any) => {
		let style: ViewStyle = {};

		if (isReverse) {
			style = {
				justifyContent: "flex-end",
				marginTop: 0,
				paddingTop: 25,
			};
		}

		return style;
	}
);

export const Title = styled.View({
	marginBottom: 12,
});

export const Body = styled.View({
	marginBottom: 12,
});

export const Hero = styled.Image({
	resizeMode: "contain",
	width: "100%",
	flex: 1,
});

export const Caption = styled.View({});

export const Pin = styled.View({
	marginBottom: 6,
	alignItems: "center",
	justifyContent: "center",
});
